<template>

  <t-page>

    <TypeCustomerDialog :no-option-add="noOptionAdd" @onSubmit="onTypeCustomerDialog"/>
    <GroupCostumerDialog :no-option-add="noOptionAdd" @onSubmit="onGroupCostumerDialog"/>
    <SellerDialog :no-option-add="noOptionAdd" @onSubmit="onSellerDialog"/>
    <PriceListDialog :no-option-add="noOptionAdd" @onSubmit="onPriceListDialog"/>
    <PaymentPlanDialog :no-option-add="noOptionAdd" @onSubmit="onPaymentPlanDialog"/>
    <BankAccountDialog :no-option-add="noOptionAdd" @onSubmit="onBankAccountDialog"/>
    <TypeOriginCustomerDialog :no-option-add="noOptionAdd" @onSubmit="onTypeOriginCustomerDialog"/>


    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmitDefault"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-form-tab title="Dados Básicos" active>

          <t-input v-model="form.customerId" hidden/>

          <t-form-card title="Cadastro" icon-building>

            <e-person :person="form.person" v-if="form.person" :command="command" address-relation-name="addressDefault"
                      :error="error_person" :status="status" @getApi="getEmbedCNPJApi">

              <b-row>

                <t-input v-model="form.customerNumber" label="Cód. Cliente" cols="4" fixed/>

                <t-input v-model="form.typeCustomerId" cols="4"
                         :options="typeCustomerOptions" :add-error="error.typeCustomerId"
                         label="Perfil" select>

                  <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-type-customer',search)">Cadastrar Perfil de Cliente</b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar Tipo de Cliente" @click="openDialogForm('modal-type-customer')"
                              icon-plus/>
                  </template>

                </t-input>

                <t-input v-model="form.customerGroupId" cols="4"
                         :options="customerGroupOptions" :add-error="error.customerGroupId"
                         label="Grupo de Clientes"
                         help="Utilize o grupo de clientes para agrupar diferentes filiais em um único local, podendo centralizar preferências pela matriz."
                         select>

                  <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-group-customer',search)">Cadastrar Grupo de Cliente</b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar Grupo de Cliente" @click="openDialogForm('modal-group-customer')"
                              icon-plus/>
                  </template>

                </t-input>

              </b-row>

            </e-person>

            <e-address :address="form.addressDefault" :command="command" name="addressDefault" :status="status"
                       @getApi="getEmbedAddressApi"/>

            <b-form-checkbox v-model="form.hasAddressDelivery" switch>
              <small>Endereço de entrega diferente?</small>
              <t-help title="Marque, caso o haja um endereço de entrega diferente do cadastro."/>
            </b-form-checkbox>

          </t-form-card>

          <t-form-card v-if="form.hasAddressDelivery" title="Endereço Entrega" icon-truck>
            <e-address :address="form.addressDelivery" :command="command" name="addressDelivery" :status="status"
                       @getApi="getEmbedAddressApi"/>
          </t-form-card>

          <t-form-card title="Dados Fiscais">

            <template #icon>
              <b-icon-receipt></b-icon-receipt>
            </template>

            <div class="form-card-header">
              <t-input not-row label="Perfil para NF-e"
                       v-model="form.invoiceBRTypeProfile"
                       :options="typeInvoiceBROptions" required radio/>
            </div>

            <b-row>


              <t-input cols="6" v-model="form.invoiceEmail"
                       label="E-mail envio NF-e"
              />


              <t-input cols="6"
                       required
                       v-model="form.typeProfileTaxationId"
                       :options="typeProfileTaxationOptions"
                       label="Regime Tributação" select
              />

              <t-input cols="6"
                       label="Insc. Estadual - Indicador"
                       help="Campo utilizado nas emissões de NFs informando o tipo de Inscrição Estatual do cliente Pessoa Jurídica"
                       :required="form.person && form.person.typePerson===2" :disabled="form.person && form.person.typePerson===1"
                       v-model="form.invoiceBRCompanyTypeStateRegistration"
                       :options="invoiceBRCompanyTypeStateRegistrationOptions"
                       :add-error="error.invoiceBRCompanyTypeStateRegistration" select-common
              />


              <t-input cols="6" v-model="form.suframa"
                       help="Ao vender um produto para uma empresa localizada na região da Zona Franca de Manaus ou em uma Área de Livre Comércio, poderá ser necessário aplicar benefícios tributários como isenção de ICMS ou suspensão de IPI, e poderá ser necessário informar a Inscrição SUFRAMA do destinatário para gerar a NF-e."
                       label="Suframa"
              />

            </b-row>

          </t-form-card>

          <t-form-card title="Qualidade">

            <t-input v-model="form.qualityEmail" label="E-mail para envio de Certificado de Qualidade" email-multiple help="Utilizado somente quando implementado o módulo de emissão de Certificados de Qualidade." />

          </t-form-card>

          <t-form-card title="Faturamento" icon-cash-stack>

            <b-row>

              <b-col cols="4">

                <div class="d-flex" style="justify-content: space-between">

                  <div>Empresa <em class="small">preferêncial ou determinada</em></div>

                  <b-form-checkbox switch>

                    <small>Bloquear</small><!--Obrigar preenchimento para marcado como bloqueado -->
                    <t-help
                        title="Caso bloqueado não será possível alteração em orçamentos, pedidos e notas fiscais para este cliente. Exceto usuários com validação de acesso 'Permissão geral para alterar preferências de faturamento bloqueadas'."/>
                  </b-form-checkbox>

                </div>

                <t-input v-model="form.companyId"
                         :options="companyOptions" :add-error="error.companyId"
                         label="Empresa" hide-label select/>

              </b-col>

              <b-col cols="4">

                <div class="d-flex" style="justify-content: space-between">

                  <div>Vendedor</div>

                  <b-form-checkbox switch>

                    <small>Bloquear</small><!--Obrigar preenchimento para marcado como bloqueado -->
                    <t-help
                        title="Caso bloqueado não será possível alteração em orçamentos, pedidos e notas fiscais para este cliente. Exceto usuários com validação de acesso 'Permissão geral para alterar preferências de faturamento bloqueadas'."/>
                  </b-form-checkbox>

                </div>


                <t-input v-model="form.sellerId"
                         :options="sellerOptions" :add-error="error.sellerId"
                         label="Vendedor" hide-label select>

                  <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-seller',search)">Cadastrar Vendedor</b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar Vendedor" @click="openDialogForm('modal-seller')"
                              icon-plus/>
                  </template>

                </t-input>


              </b-col>


              <b-col cols="4">

                <div class="d-flex" style="justify-content: space-between">

                  <div>Tabela de Preço</div>

                  <b-form-checkbox switch>

                    <small>Bloquear</small><!--Obrigar preenchimento para marcado como bloqueado -->
                    <t-help
                        title="Caso bloqueado não será possível alteração em orçamentos, pedidos e notas fiscais para este cliente. Exceto usuários com validação de acesso 'Permissão geral para alterar preferências de faturamento bloqueadas'."/>
                  </b-form-checkbox>

                </div>


                <t-input v-model="form.priceListId"
                         :options="priceListOptions" :add-error="error.priceListId"
                         label="Tabela de Preço" select hide-label>

                  <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-price-list',search)">Cadastrar Tabela de Preços</b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar Tabela de Preços" @click="openDialogForm('modal-price-list')"
                              icon-plus/>
                  </template>

                </t-input>


              </b-col>


            </b-row>


            <b-row>

              <b-col cols="4">

                <div class="d-flex" style="justify-content: space-between">

                  <div>Forma Pagamento</div>

                  <b-form-checkbox switch>

                    <small>Bloquear</small><!--Obrigar preenchimento para marcado como bloqueado -->
                    <t-help
                        title="Caso bloqueado não será possível alteração em orçamentos, pedidos e notas fiscais para este cliente. Exceto usuários com validação de acesso 'Permissão geral para alterar preferências de faturamento bloqueadas'."/>
                  </b-form-checkbox>

                </div>

                <!--Forma de Pagamento é bloqueado para cadastro nas contas, uma vez que existem diversas regras aplicáveis para geração de boleto, etc.-->
                <t-input v-model="form.typePaymentId"
                         :options="typePaymentOptions" :add-error="error.typePaymentId"
                         label="Forma Pagamento" select hide-label>

                </t-input>

              </b-col>


              <b-col cols="4">

                <div class="d-flex" style="justify-content: space-between">

                  <div>Plano de Pagamento</div>

                  <b-form-checkbox switch>

                    <small>Bloquear</small><!--Obrigar preenchimento para marcado como bloqueado -->
                    <t-help
                        title="Caso bloqueado não será possível alteração em orçamentos, pedidos e notas fiscais para este cliente. Exceto usuários com validação de acesso 'Permissão geral para alterar preferências de faturamento bloqueadas'."/>
                  </b-form-checkbox>

                </div>

                <t-input v-model="form.paymentPlanId"
                         :options="paymentPlanOptions" :add-error="error.paymentPlanId"
                         label="Plano de Pagamento" select hide-label>

                  <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-payment-plan',search)">Cadastrar Plano de Pagamento</b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar Plano de Pagamento" @click="openDialogForm('modal-payment-plan')"
                              icon-plus/>
                  </template>

                </t-input>

              </b-col>

              <b-col cols="4">

                <div class="d-flex" style="justify-content: space-between">

                  <div>Conta Bancária
                    <t-help title="Conta bancária para recebimento"/>
                  </div>

                  <b-form-checkbox switch>

                    <small>Bloquear</small><!--Obrigar preenchimento para marcado como bloqueado -->
                    <t-help
                        title="Caso bloqueado não será possível alteração em orçamentos, pedidos e notas fiscais para este cliente. Exceto usuários com validação de acesso 'Permissão geral para alterar preferências de faturamento bloqueadas'."/>
                  </b-form-checkbox>

                </div>

                <t-input v-model="form.bankAccountId"
                         :options="bankAccountOptions" :add-error="error.bankAccountId"
                         label="Conta Receita" select hide-label>

                  <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-bank-account',search)">Cadastrar Conta Bancária</b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar Conta Bancária" @click="openDialogForm('modal-bank-account')"
                              icon-plus/>
                  </template>

                </t-input>

              </b-col>

            </b-row>

          </t-form-card>

          <t-form-card title="Informações" icon-info-square>

            <b-row>

              <t-input v-model="form.typeOriginCustomerId" cols="8"
                       :options="typeOriginCustomerOptions"
                       label="Origem do Cliente" select>

                <template #no-options="{search}">
                  <b-link @click="addNoOption('modal-type-origin-customer',search)">Cadastrar Origem</b-link>
                </template>

                <template #input-group-append>
                  <t-button title="Adicionar nova Origem" @click="openDialogForm('modal-type-origin-customer')"
                            icon-plus/>
                </template>

              </t-input>

              <t-input cols="4" v-model="form.customerSince" label="Cliente desde" date/>


            </b-row>

            <b-row>

              <t-input cols="6" v-model="form.site" label="Site" url/>
              <t-input cols="6" v-model="form.linkedin" label="Linkedin"/>

            </b-row>

            <t-page-form-field-customized
                ref="fieldsGeneral"
                :command="command" :status="status" :user-auth="userAuth"
                :fields-customizable="entityFieldCustomized('page')"
                :primary-key="form.productId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
                :primary-key-column="fieldKey" foreign-key-column="pageId"
            />

            <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

            <t-input-status text="Cliente" class="ml-1" v-model="form.status"/>

          </t-form-card>


        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Contatos" hash="contact">
            <t-msg info>Em desensolvimento</t-msg>
        </t-form-tab>

        <t-form-tab title="Financeiro"  hash="financial">

          <t-msg info>Em desensolvimento</t-msg>
<!--          Limite de para recebimento, além de resumo de pagamento em formato dashboard-->

        </t-form-tab>

        <t-form-tab title="Especificações"  hash="specification">

          <t-msg info>Em desensolvimento</t-msg>
          <b-row>

<!--            - Códigos do Cliente
            - Detalhes relacionados a produtos e exibidos todos aqui
            - Quadro 'Produção' com os campso perfil de produção / perfil de qualidade-->


            <!--            <t-input cols="4" v-model="form.productionProfileId" label="Perfil Produção" help="Texto Texto"
                                 select/>

                        <t-input cols="4" v-model="form.qualityProfileId" label="Perfil Qualidade"
                                 help="Selecione conforme o perfil de qualidade exigida para o cliente, junto com o perfil serão consideradas atribuições como envio de certificado via e-mail ou impresso "
                                 select/>-->

          </b-row>

<!--          Regras específicas aplicadas a este cliente que fogem o padrão geral-->

        </t-form-tab>

        <t-form-tab title="Anexos" hash="file">
          <t-msg info>Em desensolvimento</t-msg>
        </t-form-tab>

        <t-form-tab title="Comentários" hash="comment">
          <t-msg info>Em desensolvimento</t-msg>
        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>
<script>

import TypeCustomerDialog from "@/views/modules/customer/TypeProfileDialog"
import GroupCostumerDialog from "@/views/modules/customer/GroupCostumerDialog"
import SellerDialog from "@/views/modules/business/SellerDialog"
import PriceListDialog from "@/views/modules/business/PriceListDialog"
import PaymentPlanDialog from "@/views/modules/business/PaymentPlanDialog"
import BankAccountDialog from "@/views/modules/financial/BankAccountDialog"
import TypeOriginCustomerDialog from "@/views/modules/customer/TypeOriginDialog"

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ePerson from "@/views/embed/general/e-person"
import eAddress from "@/views/embed/general/e-address"

import http from "@/services/config/http-common"
import pageFormEmbeddableMixin from "@/mixins/page/pageFormEmbeddableMixin";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormEmbeddableMixin],
  components: {
    ePerson,
    eAddress,
    TypeCustomerDialog,
    GroupCostumerDialog,
    SellerDialog,
    PriceListDialog,
    PaymentPlanDialog,
    BankAccountDialog,
    TypeOriginCustomerDialog
  },
  name: 'CustomerFormERPEmbeddable',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "customerId",
      enableGeneralFields: true,
      /*FORM DECLARADO NO MIXIM PARA VIR DE FORA COM OS CAMPOS PADRÕES JUNTOS COM OS CUSTOMIZADOS*/
      error: {//Campos que podem receber retorno de erro do backend
        otherCodeLabel: "",
        typeCustomerId: "",
        customerGroupId: "",
        invoiceBRCompanyTypeStateRegistration: "",
        companyId: "",
        sellerId: "",
        priceListId: "",
        typePaymentId: "",
        paymentPlanId: "",
        bankAccountId: "",
      },
      /*Embed Person Errors version: 1.0*/
      error_person: {
        name: "",
        federalTaxpayer: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      companyOptions: [],
      typeCustomerOptions: [],
      customerGroupOptions: [],
      priceListOptions: [],
      typePaymentOptions: [],
      sellerOptions: [],
      paymentPlanOptions: [],
      bankAccountOptions: [],
      typeOriginCustomerOptions: [],
      typeProfileTaxationOptions: [
        {value: 1, text: "Simples Nacional"}, {value: 2, text: "Lucro Presumido"}, {value: 9, text: "Lucro Real"}
      ],
      typeInvoiceBROptions: [{value: 1, text: "Industrialização"}, {value: 2, text: "Revenda"}, {
        value: 3,
        text: "Uso e Consumo"
      }],
      invoiceBRCompanyTypeStateRegistrationOptions: [{value: 1, text: "Contribuite ICMS"}, {
        value: 2,
        text: "Contribuinte Isento"
      }, {value: 9, text: "Não contribuinte"}
      ],
      //--------------------------------------------------------------------------------------
    }
  },

  methods: {

    mountedPrepare() {
        this.mountedPrepareEmbeddable() //Sempre no início de mountedPrepare
    },
    async mountedContinued() {

      await http.list("customer/selectRelationList").then((response) => {

        this.companyOptions = response.companyOptions
        this.typeCustomerOptions = response.typeCustomerOptions
        this.customerGroupOptions = response.customerGroupOptions
        this.priceListOptions = response.priceListOptions
        this.typePaymentOptions = response.typePaymentOptions
        this.sellerOptions = response.sellerOptions
        this.paymentPlanOptions = response.paymentPlanOptions
        this.bankAccountOptions = response.bankAccountOptions
        this.typeOriginCustomerOptions = response.typeOriginCustomerOptions

      }).catch(error => this.responseError(error))

      this.mountedContinuedEmbeddable() //Sempre no final de mountedContinued

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onTypeCustomerDialog(itemInserted) {

      this.form.typeCustomerId = itemInserted.value
      this.typeCustomerOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    onGroupCostumerDialog(itemInserted) {

      this.form.customerGroupId = itemInserted.value
      this.customerGroupOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    onSellerDialog(itemInserted) {

      this.form.sellerId = itemInserted.value
      this.sellerOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    onPriceListDialog(itemInserted) {

      this.form.priceListId = itemInserted.value
      this.priceListOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },
    onPaymentPlanDialog(itemInserted) {

      this.form.paymentPlanId = itemInserted.value
      this.paymentPlanOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },
    onBankAccountDialog(itemInserted) {

      this.form.bankAccountId = itemInserted.value
      this.bankAccountOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },
    onTypeOriginCustomerDialog(itemInserted) {

      this.form.typeOriginCustomerId = itemInserted.value
      this.typeOriginCustomerOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
